import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../../services/security.js";
import auth from "../../../services/auth.js";
import events from "../../../services/events.js";
import companies from "../../../services/companies.js";

class BasicprofileController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    ProfileService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope
  ) {
    this.name = "basicprofile";
    $localStorage.activeStateName = "basicprofile";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$profile = ProfileService;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$common = CommonService;
    this.pref_jobble_types = [];
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.sections = {
      section_1: {is_clear: false},
      section_2: {is_clear: false},
      section_3: {is_clear: false},
    };
    //ssn: false,
    this.ui_model = {
      error_model: {
        preferred_name: false,
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        ssn_display: null,
        address1: false,
        address2: false,
        city: false,
        state: false,
        zip_code: false,
        bio: false,
      },
      warning_model: {email: false},
      submit_model: {
        form1: {is_disabled: true},
        form2: {is_disabled: true},
        form3: {is_disabled: true},
      },
    };
    //ssn: null,
    this.loading = true;
    this.currentUser = this.$auth.getUserData();
    this.basicprofile_info = {
      basic: {
        personal_details: {
          preferred_name: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          bio: null,
          dateBirth: null,
        },
        address: {
          street: null,
          apt: null,
          city: null,
          state: null,
          zip_code: null,
        },
        options: {
          preferred_jobble_types: [],
        },
        image: {
          url: null,
        },
      },
      extended: {},
    };

    window.toastr.options.preventDuplicates = true;

    //INIT FUNCTIONS
    this.states = {
      value: "--",
      values: [
        "--",
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    };
    this.getLatestUserData(this.$stateParams.basicprofileId);

    this.SetJobForApplicationAfterBasicFilledListener = this.$rootScope.$on("SetJobForApplicationAfterBasicFilled", ($event, params) => {
      this.job_from_board_during_apply_attempt = params.job;
    });

    this.$scope.$on("$destroy", this.TriggerIndicatorDataListener);
    this.$scope.$on("$destroy", this.SetJobForApplicationAfterBasicFilledListener);
  }

  getLatestUserData(id) {
    var _this = this;
    if (_this.currentUser) {
      _this.$profile.validateUserByToken(_this.currentUser.access_token).then(
        function (response) {
          _this.setUserDataToView(response.data);
        },
        function (error) {}
      );
    } else {
      alert("we have no user....");
    }
  }

  getJobbleTypes(jobbleTypesParam, user) {
    var user_obj = user;

    console.log("jobbleTypesParam");
    console.dir(jobbleTypesParam);

    this.$auth.getJobbleTypes().then((data) => {
      this.jobble_types = data.data;
      this.$rootScope.jobble_types = data.data;
      this.setNotiJobbleTypes(jobbleTypesParam, user_obj);
    });
  }

  setUserDataToView(user) {
    console.log("setUserDataToView");
    console.dir(user);

    this.basicprofile_info.basic.personal_details.preferred_name = user.nickname;
    this.basicprofile_info.basic.personal_details.first_name = user.firstName;
    this.basicprofile_info.basic.personal_details.last_name = user.lastName;
    this.basicprofile_info.basic.personal_details.email = user.email;
    this.basicprofile_info.basic.personal_details.dateBirth = user.dateBirth ? this.convertDateToString(user.dateBirth) : null;
    //user.ssn &&
    if (user.homeContactInfo.phoneMobile && user.bio && user.dateBirth) {
      this.sections.section_1.is_clear = true;
    }

    if (user.homeContactInfo.phoneMobile) {
      this.basicprofile_info.basic.personal_details.phone = user.homeContactInfo.phoneMobile;
    } else {
      this.ui_model.error_model.phone = true;
    }

    /*
        if (user.ssn) {
            this.basicprofile_info.basic.personal_details.ssn_display = this.formatSsn(user.ssn);
            this.basicprofile_info.basic.personal_details.ssn = user.ssn;
        } else {
            this.ui_model.error_model.ssn = true;
        }
        */

    if (user.bio) {
      this.basicprofile_info.basic.personal_details.bio = user.bio;
    } else {
      this.ui_model.error_model.bio = true;
    }

    this.basicprofile_info.basic.image.url = user.filePROFILE_IMAGE1IMG_160x160;
    this.basicprofile_info.basic.address.zip_code = user.homeContactInfo.zipCode;

    if (user.homeContactInfo.streetLine1) {
      this.basicprofile_info.basic.address.street = user.homeContactInfo.streetLine1;
    } else {
      this.ui_model.error_model.address1 = true;
    }

    if (user.homeContactInfo.city) {
      this.basicprofile_info.basic.address.city = user.homeContactInfo.city;
    } else {
      this.ui_model.error_model.city = true;
    }

    this.basicprofile_info.basic.address.apt = user.homeContactInfo.streetLine2;

    if (user.homeContactInfo.state) {
      this.states.value = user.homeContactInfo.state;
    } else {
      this.ui_model.error_model.state = true;
    }

    if (user.homeContactInfo.streetLine1 && user.homeContactInfo.city && user.homeContactInfo.state) {
      this.sections.section_2.is_clear = true;
    }

    let left_rail_data = {};
    left_rail_data.image = user.filePROFILE_IMAGE1IMG_160x160;
    left_rail_data.first_name = user.firstName;
    left_rail_data.last_name = user.lastName;

    this.$timeout(() => {
      this.$rootScope.$emit("SetProfileImageForJobbler", {
        user: left_rail_data,
      });
    });

    console.log("before getJobbleTypes");
    console.dir(user);

    this.getJobbleTypes(user.notifPref.jobbleTypes, user);

    console.log("this might be the last thing?");
    console.dir(this.ui_model);

    this.sendProfileData();
    this.currentUser = user;

    this.$timeout(() => {
      $("#datepicker").datepicker({
        changeMonth: true,
        changeYear: true,
        minDate: "-100Y",
        maxDate: "-18Y",
        yearRange: "-100:-18",
      });
    });
  }

  sendProfileData() {
    console.log("sendProfileData");
    this.$timeout(() => {
      this.$rootScope.$emit("ProfileStatusCheck", this.ui_model);
    });
  }

  formatSsn(ssn) {
    let tempSsn = ssn.substring(5, 9);
    tempSsn = "*****" + tempSsn;
    return tempSsn;
  }

  setNotiJobbleTypes(jobble_types, user) {
    var _this = this;

    var user_obj = user;

    if (jobble_types) {
      _this.display_pref_jt_warning = false;
      _this.sections.section_3.is_clear = true;
      try {
        jobble_types.forEach(function (j) {
          let jt = _this.jobble_types.find((o) => o.id === j.id);

          if (jt) {
            jt.selected = true;
            _this.pref_jobble_types.push(jt.id);
          }
        });
      } catch (err) {
        console.log("in error");
        console.dir(err);
      } finally {
        _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
        _this.$timeout(function () {
          _this.loading = undefined;
        }, 100);
      }
    } else {
      _this.display_pref_jt_warning = true;
      _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
      _this.$timeout(function () {
        _this.loading = undefined;
      }, 100);
    }
  }

  setEmailWarning() {
    this.ui_model.warning_model.email = this.compareEmails();
  }

  formChange(field, page) {
    const user = this.mapFields();
    this.errors = this.errors || {};

    if (field === "email") {
      this.setEmailWarning();
    }

    this.$timeout(() => {
      this.errors = this.$profile.validateProfile(user, field, this.errors);

      console.log("what are the errors");
      console.dir(this.errors);
    });
  }

  isValidMultiple(fields) {
    let valid = true;
    const user = this.mapFields();

    if (!fields) return valid;

    fields.forEach((field) => {
      this.errors = this.$profile.validateProfile(user, field, this.errors);
      if (this.errors[field]) valid = false;
    });

    return valid;
  }

  formChangeOld(field, form_id) {
    var _this = this;
    if (form_id === 1) {
      if (field === "first_name") {
        this.ui_model.error_model.first_name = this.basicprofile_info.basic.personal_details.first_name.length <= 0;
      }
      if (field === "last_name") {
        this.ui_model.error_model.last_name = this.basicprofile_info.basic.personal_details.last_name.length <= 0;
      }
      /*
      if (field === "ssn") {
        if (this.basicprofile_info.basic.personal_details.ssn) {
          this.ui_model.error_model.ssn = false;
        } else if (_this.basicprofile_info.basic.personal_details.ssn === "") {
          this.ui_model.error_model.ssn = true;
        }
      }
      */
      if (field === "phone") {
        if (this.basicprofile_info.basic.personal_details.phone) {
          let is_phone = this.$profile.isPhone(this.basicprofile_info.basic.personal_details.phone);
          this.ui_model.error_model.phone = !is_phone;
        } else {
          this.ui_model.error_model.phone = true;
        }
      }
      if (field === "email") {
        this.setEmailWarning();
        if (this.basicprofile_info.basic.personal_details.email) {
          let is_email = this.$profile.isEmail(this.basicprofile_info.basic.personal_details.email);
          this.ui_model.error_model.email = !is_email;
        } else {
          this.ui_model.error_model.email = true;
        }
      }
      if (field === "bio") {
        if (this.basicprofile_info.basic.personal_details.bio) {
          this.ui_model.error_model.bio = false;
        }
      }
      //this.basicprofile_info.basic.personal_details.ssn &&
      if (
        this.ui_model.error_model.phone === false &&
        this.ui_model.error_model.bio === false &&
        this.ui_model.error_model.first_name === false &&
        this.ui_model.error_model.last_name === false &&
        this.ui_model.error_model.email === false &&
        this.ui_model.error_model.year === false
      ) {
        this.ui_model.submit_model.form1.is_disabled = false;
      } else {
        this.ui_model.submit_model.form1.is_disabled = true;
      }
    } else if (form_id === 2) {
      if (field === "address1") {
        this.ui_model.error_model.address1 = !this.basicprofile_info.basic.address.street;
      }
      if (field === "city") {
        this.ui_model.error_model.city = !this.basicprofile_info.basic.address.city;
      }
      if (field === "state") {
        this.ui_model.error_model.state = !(this.states.value && this.states.value !== "--");
      }
      if (field === "zip_code") {
        this.ui_model.error_model.zip_code = !(
          this.basicprofile_info.basic.address.zip_code && this.basicprofile_info.basic.address.zip_code.length === 5
        );
      }
      if (
        this.ui_model.error_model.zip_code === false &&
        this.ui_model.error_model.state === false &&
        this.ui_model.error_model.city === false &&
        this.ui_model.error_model.address1 === false
      ) {
        this.ui_model.submit_model.form2.is_disabled = false;
      } else {
        this.ui_model.submit_model.form2.is_disabled = true;
      }
    } else {
      this.ui_model.submit_model.form3.is_disabled = false;
    }
  }

  validate_years(days, months, years) {
    let result = {};
    let current_year = moment().format("YYYY");
    let current_year_less_18 = moment().subtract(18, "years").format("YYYY");
    let year_input = parseInt(years, 10);
    let cyl18 = parseInt(current_year_less_18, 10);
    if (year_input === cyl18) {
      let current_month = parseInt(moment().format("MM"), 10);
      let month_input = parseInt(months, 10);
      if (month_input === current_month) {
        let day = parseInt(moment().format("DD"), 10);
        let day_input = parseInt(days, 10);
        if (day_input < day) {
          console.log("first one");
          result.bool = false;
          result.msg = "You need to be over the age of 18 to finish your basic profile.";
        } else {
          console.log("first second");
          result.bool = true;
        }
      } else if (current_month > month_input) {
        result.bool = false;
        result.msg = "You need to be over the age of 18 to finish your basic profile.";
      } else if (current_month < month_input) {
        result.bool = true;
      }
    } else {
      result.bool = true;
    }
    return result;
  }

  compareEmails() {
    var _this = this;
    let ans = null;
    if (_this.currentUser.email === _this.basicprofile_info.basic.personal_details.email) {
      ans = false;
    } else {
      ans = true;
    }
    return ans;
  }

  saveUser() {
    if (this.profileSaving === true) {
      return;
    }

    let user = this.mapFields();

    if (user.preferredName) {
      user.nickname = user.preferredName;
    }
    //"ssn",
    let pageValid = this.isValidMultiple([
      "preferredName",
      "firstName",
      "lastName",
      "phoneMobile",
      "dateBirth",
      "streetLine1",
      "zipCode",
      "city",
      "state",
      "bio",
    ]);

    if (!pageValid) return;

    this.setLoader();
    this.profileSaving = true;

    let was_email_changed = this.compareEmails();

    this.$profile.saveUser(user).then(
      (response) => {
        this.$timeout(() => {
          this.profileSaving = false;
        }, 3000);

        if (this.toggleModal) {
          this.toggleModal();
        }

        if (response.data.status === "error") {
          console.error(response);
          if (response.data.message.indexOf("Duplicate entry") > -1) {
            window.toastr.error(
              "<i class=\"fas fa-times\" style='margin-right: 8px'></i>This email has already been registered in our system. Please try another or contact support."
            );
          } else if (response.data.message.indexOf("ssn is already used") > -1) {
            window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>This ssn already exists. Please contact support.");
          } else {
            window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>There was an issue saving your profile. Please try again");
          }
        } else {
          this.profile_updated_successfully = true;
          this.sections.section_1.is_clear = true;

          if (window.toastr) {
            window.toastr.options.preventDuplicates = true;
            window.toastr.success("<i class=\"fas fa-check-circle\" style='margin-right: 8px'></i>Success! Your profile was updated");
          }

          this.$timeout(() => {
            this.profile_updated_successfully = false;
          }, 3500);

          if (was_email_changed) {
            this.$timeout(() => {
              this.$rootScope.$emit("SignUserOut", {});
            });
          } else {
            this.handleResponse(response.data);
          }
        }

        this.unSetLoader();
      },
      (error) => {
        this.$timeout(() => {
          this.profileSaving = false;
        }, 1000);

        if (this.toggleModal) {
          this.toggleModal();
        }
        this.unSetLoader();

        if (error.data.message.indexOf("ssn is already used") > -1) {
          window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>This ssn already exists. Please contact support.");
        } else if (error.data.code === 3200) {
          alert("The phone number you are trying to save is in an invalid format. Please enter only 10 digits.");
        } else if (error.data.code === 3201) {
          alert("The phone number you are trying to save is already in use by another user.");
        } else {
          alert("There was a fatal backend error. Please contact support.");
        }
      }
    );
  }

  checkToMakeSureAllFieldsAreFilledOut(user) {
    var _this = this;
    if (
      _this.sections.section_1.is_clear === true &&
      _this.sections.section_2.is_clear === true &&
      _this.sections.section_3.is_clear === true &&
      _this.job_from_board_during_apply_attempt
    ) {
      let job = _this.job_from_board_during_apply_attempt;
      _this.$timeout(function () {
        _this.$state.go("jobblergallery", {
          job,
          display_warning: true,
        });
      }, 500);
    }
    if (
      _this.sections.section_1.is_clear &&
      _this.sections.section_2.is_clear &&
      _this.sections.section_3.is_clear &&
      user.filePROFILE_IMAGE1IMG_160x160
    ) {
      _this.status_clear = true;
    } else {
      _this.status_clear = false;
    }
  }

  handleResponse(response) {
    var _this = this;
    console.log("handleResponse response");
    console.dir(response);
    _this.$auth.validateUserByToken(_this.currentUser.access_token).then(
      function (r) {
        _this.$localStorage.logged_user = r.data;
        _this.currentUser = r.data;
        _this.set_current_user_to_parent(r.data);
        if (_this.job_from_board_during_apply_attempt) {
          _this.checkToMakeSureAllFieldsAreFilledOut(r.data);
        }
      },
      function (error) {
        console.log("error validating user");
        console.dir(error);
      }
    );
  }

  set_current_user_to_parent(user) {
    var _this = this;
    console.log("set_current_user_to_parent");
    console.dir(user);
    _this.$timeout(function () {
      _this.$rootScope.$emit("SettingNewUserDataToParent", user);
      _this.$rootScope.$emit("ProfileStatusCheck", _this.ui_model);
    });
  }

  mapFields() {
    //ssn: this.basicprofile_info.basic.personal_details.ssn,
    let user = {
      preferredName: this.basicprofile_info.basic.personal_details.preferred_name,
      firstName: this.basicprofile_info.basic.personal_details.first_name,
      lastName: this.basicprofile_info.basic.personal_details.last_name,
      email: this.basicprofile_info.basic.personal_details.email,
      username: this.basicprofile_info.basic.personal_details.email,
      bio: this.basicprofile_info.basic.personal_details.bio,
      homeContactInfo: {
        phoneMobile: this.basicprofile_info.basic.personal_details.phone,
        streetLine1: this.basicprofile_info.basic.address.street,
        streetLine2: this.basicprofile_info.basic.address.apt,
        city: this.basicprofile_info.basic.address.city,
        state: this.states.value,
        zipCode: this.basicprofile_info.basic.address.zip_code,
      },
    };

    if (this.basicprofile_info.basic.personal_details.dateBirth) {
      const date = new Date(this.basicprofile_info.basic.personal_details.dateBirth);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      user.dateBirth =
        year + "-" + ((month + "").length === 1 ? "0" + month : month) + "-" + ((day + "").length === 1 ? "0" + day : day) + "T00:00:00Z";
    }

    /*
        if (this.basicprofile_info.basic.personal_details.ssn_display) {
            if (this.basicprofile_info.basic.personal_details.ssn_display.startsWith("*****")) {
                user.ssn = this.basicprofile_info.basic.personal_details.ssn;
            } else {
                user.ssn = this.basicprofile_info.basic.personal_details.ssn_display;
            }
        }*/

    return user;
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  convertDateToString(indate) {
    const date = new Date(indate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate() + 1;
    return ((month + "").length === 1 ? "0" + month : month) + "/" + ((day + "").length === 1 ? "0" + day : day) + "/" + year;
  }
}

BasicprofileController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "profile",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
];

export default BasicprofileController;



// WEBPACK FOOTER //
// ./client/app/components/jobbler/basicprofile/basicprofile.controller.js